/*
 * @Description:
 * @Date: 2024-12-13 17:06:19
 */
import {
  useInputColumn,
  useSelectColumn,
  useDatePickerColumn
} from 'xrk-components';
import {
  IS_OVERDUE,
  SETTLEMENT_STATUS,
  CANCEL_STATUS,
  USER_TYPE
} from '../constants/index';
import { ProjectType } from '../types';
import { userTags } from '../data-source/apis';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { useRoute } from 'vue-router';
import { IS_ASSISTANT } from '@/config';

/** 提交时间 */
export const timeSearch = useDatePickerColumn({
  prop: 'editStatusAt',
  label: '提交时间',
  style: {
    width: '240px'
  },
  config: {
    type: 'daterange',
    startPlaceholder: '提交时间始',
    endPlaceholder: '提交时间止',
    shortcuts: [
      {
        text: '昨日',
        value: () => {
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          const end = start;
          return [start, end];
        }
      },
      {
        text: '今日',
        value: () => {
          const end = new Date();
          const start = new Date();
          return [start, end];
        }
      },
      {
        text: '近一周',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          return [start, end];
        }
      },
      {
        text: '近一月',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          return [start, end];
        }
      },
      {
        text: '近三个月',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          return [start, end];
        }
      },
      {
        text: '近半年',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
          return [start, end];
        }
      },
      {
        text: '近一年',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
          return [start, end];
        }
      }
    ]
  }
});

/** 拜访时间 */
export const visitDtOrderSearch = useDatePickerColumn({
  prop: 'visitDt',
  label: '拜访时间',
  style: {
    width: '240px'
  },
  config: {
    type: 'daterange',
    startPlaceholder: '拜访时间始',
    endPlaceholder: '拜访时间止'
  }
});

/** 手机号 */
export const phoneSearch = useInputColumn({
  label: '手机号',
  prop: 'phone',
  type: 'input',
  config: {
    type: 'tel',
    placeholder: '请输入手机号'
  }
});

/** 人员标签 */
export const userTagSearch = useInputColumn({
  type: 'autocomplete' as any,
  prop: 'userTag',
  label: '人员标签',
  config: {
    clearable: true,
    placeholder: '请选择',
    fetchSuggestions: async (value, cb) => {
      const store = useProjectDetailStore();
      const { data } = await userTags({
        projectId: store.baseData.projectInfo.id
      });
      const list = data.map(item => {
        return { value: item.label, label: item.label };
      });

      return cb(list.filter(i => !value || i.value?.indexOf(value) > -1));
    }
  } as any
});

/** 个体工商户名称 */
export const individualNameSearch = useInputColumn({
  prop: 'individualName',
  type: 'input',
  label: '个体工商户名称',
  config: {
    placeholder: '请输入',
    maxlength: 50,
    inputTextReplace: true,
    inputTexts: ['汉字', '英文字母']
  }
});

/** 所属园区 */
export const parkNameSearch = useInputColumn({
  prop: 'businessParkName',
  type: 'input',
  label: '所属园区',
  config: {
    placeholder: '请输入所属园区',
    maxlength: 50,
    inputTextReplace: true,
    inputTexts: ['汉字', '英文字母']
  }
});

/** 终端服务人员 */
export const userNameSearch = useInputColumn({
  prop: 'username',
  type: 'input',
  label: '终端服务人员',
  config: {
    placeholder: '请输入'
  }
});

/** 任务编码 */
export const taskCodeSearch = useInputColumn({
  prop: 'taskCode',
  type: 'input',
  label: '任务编码',
  config: {
    placeholder: '请输入任务编码'
  }
});

/** 是否已完成 */
export const isCompletedSearch = useSelectColumn({
  prop: 'finishState',
  label: '是否已完成',
  config: {
    placeholder: '请选择是否已完成',
    options: {
      1: { label: '已完成', value: '1' },
      0: { label: '未完成', value: '0' }
    }
  }
});

/** 结算状态 */
export const settlementStatusSearch = useSelectColumn({
  prop: 'dataState',
  label: '结算状态',
  config: {
    placeholder: '请选择结算状态',
    options: SETTLEMENT_STATUS,
    clearable: false
  },
  defaultValue: '0'
});

/** 是否过期 */
export const isOverdueSearch = useSelectColumn({
  prop: 'isOverdue',
  label: '是否过期',
  config: {
    placeholder: '请选择是否过期',
    options: IS_OVERDUE,
    clearable: true
  }
});

/** 人员类型 */
export const userTypeSearch = useSelectColumn({
  prop: 'userType',
  label: '人员类型',
  config: {
    placeholder: '请选择人员类型',
    options: USER_TYPE,
    clearable: true
  }
});

/** 活动名称 */
export const activityNameSearch = useInputColumn({
  prop: 'taskName',
  type: 'input',
  label: '活动名称',
  config: {
    placeholder: '请输入活动名称'
  }
});
/** 是否可结算 */
export const isSettlementSearch = useSelectColumn({
  prop: 'isSettlement',
  label: '是否可结算',
  config: {
    placeholder: '请选择是否可结算',
    options: {
      0: {
        label: '否',
        value: '0'
      },
      1: {
        label: '是',
        value: '1'
      }
    }
  }
});

/** 项目执行状态 */
export const projectStatusSearch = useSelectColumn({
  prop: 'projectStatus',
  label: '项目执行状态',
  config: {
    placeholder: '请选择项目执行状态',
    options: {
      0: { label: '已停用', value: '0' },
      1: { label: '待执行', value: '1' },
      2: { label: '执行中', value: '2' }
    }
  }
});

/** 人员状态 */
export const cancelStatusSearch = useSelectColumn({
  prop: 'cancelStatus',
  label: '人员状态',
  config: {
    placeholder: '请选择人员状态',
    options: CANCEL_STATUS
  }
});

export const searchByProjectType = (
  projectType: ProjectType,
  isEntry,
  isGeti,
  isSetTime
) => {
  const query = useRoute()?.query;
  const searchItems = {
    6: [
      { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameSearch,
      isGeti && parkNameSearch,
      phoneSearch,
      userTagSearch
    ],
    21: [
      timeSearch,
      settlementStatusSearch,
      isOverdueSearch,
      { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameSearch,
      isGeti && parkNameSearch,
      phoneSearch,
      userTagSearch,
      taskCodeSearch,
      isCompletedSearch
    ],
    17: [
      timeSearch,
      visitDtOrderSearch,
      settlementStatusSearch,
      isOverdueSearch,
      { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameSearch,
      isGeti && parkNameSearch,
      phoneSearch,
      userTagSearch,
      taskCodeSearch,
      isCompletedSearch
    ],
    5: [
      timeSearch,
      settlementStatusSearch,
      isOverdueSearch,
      { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameSearch,
      isGeti && parkNameSearch,
      phoneSearch,
      userTagSearch,
      taskCodeSearch,
      isCompletedSearch
    ],
    20: [
      timeSearch,
      isSetTime && visitDtOrderSearch,
      settlementStatusSearch,
      isOverdueSearch,
      { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameSearch,
      isGeti && parkNameSearch,
      phoneSearch,
      userTagSearch,
      taskCodeSearch,
      isCompletedSearch
    ],
    19: {
      '2,2': [
        timeSearch,
        settlementStatusSearch,
        isOverdueSearch,
        { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameSearch,
        isGeti && parkNameSearch,
        phoneSearch,
        userTagSearch,
        taskCodeSearch
      ],
      '1,3': [
        timeSearch,
        settlementStatusSearch,
        isOverdueSearch,
        { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameSearch,
        isGeti && parkNameSearch,
        phoneSearch,
        userTagSearch,
        taskCodeSearch,
        { ...activityNameSearch, defaultValue: query?.activityName || '' }
      ],
      '1,1': [
        timeSearch,
        settlementStatusSearch,
        isOverdueSearch,
        { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameSearch,
        isGeti && parkNameSearch,
        phoneSearch,
        userTagSearch,
        taskCodeSearch,
        { ...activityNameSearch, defaultValue: query?.activityName || '' }
      ],
      '2,1': [
        timeSearch,
        settlementStatusSearch,
        isOverdueSearch,
        { ...userNameSearch, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameSearch,
        isGeti && parkNameSearch,
        phoneSearch,
        userTagSearch,
        taskCodeSearch
      ]
    }
  };
  // 协定服务类型
  // '1,3': '活动形式-双方共同上传',
  // '1,1': '活动形式-服务商上传',
  // '2,2': '人为维度-终端上传',
  // '2,1': '人为维度-服务商上传',
  let searchs: any[] = [];

  const target = searchItems[projectType];

  if (Array.isArray(target)) {
    searchs = target;
  } else if (typeof target === 'object' && target !== null) {
    searchs = target[isEntry as keyof typeof target] || [];
  }

  return searchs
    .filter(Boolean)
    .filter(
      search =>
        !(
          IS_ASSISTANT &&
          (search?.prop === 'isOverdue' || search?.prop === 'dataState')
        )
    );
};
